/* TEXT STRINGS */

// Shared

export const FALSE = 'false';
export const GO = 'Go';
export const TRUE = 'true';
export const START_ORDER = 'Start your order';
export const CLOSE = 'Close';
export const OPEN = 'Open';
export const APPLY = 'Apply';
export const PRODUCT_DESCRIPTION_FOR = 'product description for';
export const NUTRITION_ADULT_REQUIREMENT = 'Adults need around 2000 kcal a day';

/* page strings */

export const PAGE_TITLE = 'Our Menu';

/* component strings */

// Cookie bar

export const COOKIE_WARNING = `The cookies our site uses might not taste great, but they’re
used to give you a better online experience. By clicking ‘I Accept’,
you agree to our use of cookies.`;
export const LEARN_MORE = 'Learn more about cookies.';
export const CLOSE_COOKIE = 'close cookie bar';
export const ARIA_COOKIE = 'I accept cookies and close cookie bar';
export const COOKIE_ACCEPT = 'I Accept';
export const COOKIE_REJECT = 'I do not accept';

// filters [Allergen/diet information]

export const DISHES_DO_NOT_CONTAIN = 'Hide dishes that contain:';
export const SHOW_DISHES = 'Only show me dishes that are:';
export const CELERY = 'Celery';
export const CRUSTACEAN = 'Crustacean';
export const EGG = 'Egg';
export const FISH = 'Fish';
export const GLUTEN = 'Gluten';
export const LUPIN = 'Lupin';
export const MILK = 'Milk';
export const MOLLUSC = 'Mollusc';
export const MUSTARD = 'Mustard';
export const NUT = 'Nut';
export const PEANUT = 'Peanut';
export const SESAME = 'Sesame';
export const SOYA = 'Soya';
export const SULPHITE = 'Sulphite';
export const ALMONDS = 'Almonds';
export const HAZELNUTS = 'Hazelnuts';
export const WALNUTS = 'Walnuts';
export const BRAZIL_NUTS = 'Brazil nuts';
export const CASHEWS = 'Cashews';
export const PECANS = 'Pecans';
export const PISTACHIOS = 'Pistachios';
export const MACADAMIA_NUTS = 'Macadamia nuts';
export const FILTER_VEGGIE = 'Vegetarian';
export const FILTER_LOW_LACTOSE = 'Low lactose';
export const TRACE =
    'Hide dishes at risk of cross contamination with allergens?';
export const DISH_CONTAINS = 'This dish contains:';
export const POSSIBLE_KITCHEN_CONTAMINATION = 'Possible kitchen contamination:';
export const POSSIBLE_MANUFACTURING_CONTAMINATION =
    'Possible manufacturing contamination:';
export const FIELD_CONTAINING_GLUTEN = 'Cereals containing gluten';
export const FIELD_CONTAINING_GLUTEN_WHEAT = 'Wheat';
export const FIELD_CONTAINING_GLUTEN_RYE = 'Rye';
export const FIELD_CONTAINING_GLUTEN_BARLEY = 'Barley';
export const FIELD_CONTAINING_GLUTEN_OATS = 'Oats';
export const FIELD_CONTAINING_GLUTEN_SPELT = 'Spelt';
export const POSSIBLE_CONTAMINATION = 'Possible contamination:';
export const GLUTEN_CROSS_CONTAMINATION =
    'As bread is handled in the kitchen, please speak to the manager on duty so that extra precautions can be taken';
export const MILK_CROSS_CONTAMINATION =
    'As cheese is cooked on the grills, please speak to the manager on duty so that extra precautions can be taken';
export const CALORIES_FILTER = 'Calories';
export const HIDE_CALORIES = 'Hide calories from menu:';

// below taken from app consts file.
// approach documented here: https://nandosuk.atlassian.net/wiki/spaces/MR/pages/1854308638/Allergen+display+logic.
export const INFORMATION_DISCLAIMER_SIDE =
    'This information is based on the smallest size available.';
export const INFORMATION_PLEASE_CHECK =
    'Please check the info each time you visit as the recipe may change';
export const INFORMATION_CALL_REST =
    'If ordering, call the restaurant before you order to make them aware of your allergy and ask about our ingredients and cooking methods';
export const INFORMATION_COMBO =
    'Please check individual items for nutritional and dietary information';
export const INFORMATION_CUSTOMIZABLE_ADD_REMOVE =
    'This information is based on the dish on its own, without any customisations or added sides or extras. Please refer to the nutritional information on your preferred sides';
// end app consts.

export const ALLERGEN_ALERT = `If you’re eating in with us and have an allergy, please inform a member of staff before
ordering. For online orders, check our allergen information online before placing your order.`;
export const FILTER = 'filter';
export const FILTERS = 'filters';
export const CLOSE_FILTERS = 'Close filters';
export const OPEN_FILTERS = 'Open filters';

// footer

export const LOOP = 'Stay in the loop';
export const FACEBOOK = 'facebook';
export const TWITTER = 'twitter';
export const INSTAGRAM = 'Instagram';
export const SNAPCHAT = 'SnapChat';
export const YOUTUBE = 'YouTube';
export const SPOTIFY = 'spotify';
export const PRIVACY_POLICY = 'Privacy Policy';
export const COPYRIGHT = '© Nando’s';

// fulfilment

export const COLLECTION_EAT_IN = 'Collection/eat-in only';
export const COLLECTION_DELIVERY = 'Collection/delivery only';
export const COLLECTION_ONLY = 'Collection only';
export const DELIVERY_ONLY = 'Delivery only';
export const EAT_IN_ONLY = 'Eat in only';
export const FULFILMENT_TYPES = 'Fulfilment Types';
export const AVAILABLE_IN = 'Available in';

// PDP

export const ALLERGEN_TAB = 'Allergens';
export const NUTRITION_TAB = 'Nutritional information';
export const SIDES_TITLE = 'Sides';
export const SPICES = 'Spices';

// nandinos
export const STEP_1 = 'Step 1: Choose a spice (if available)';
export const STEP_2 = 'Step 2: Select two Nandino sides';
export const STEP_3 = 'Step 3: Choose a drink OR dessert';
export const NANDINOS_SIDES = 'Nandino sides';
export const NANDINOS_DRINK_DESSERT = 'Drink or dessert';
export const ADDITIONAL_DRINK_DESSERTS =
    'Additional drinks or desserts can be ordered separately';

// Main menu

export const LOCATION_PERMISSION = 'Please allow us access to your location';
export const MENU_NAV = 'Nando’s website navigation menu';
export const OPEN_PAGE_NAVIGATION = 'Open page navigation';
export const POSTCODE_PLACEHOLDER = 'e.g. W5 3NU';
export const IE_PLACEHOLDER = 'e.g. Dundrum';
export const SEARCH_TITLE = 'Search for a Nando’s';

// Modifiers

export const MODIFIERS_TITLE = 'Modifiers';

// Nutrition facts

export const ITEM_CONTAINS = 'This item contains:';
export const ABV = 'Alcohol by volume (%)';
export const KCAL = 'kcal';
export const ENERGY_KCAL = 'Energy (kcal)';
export const ENERGY_KJ = 'Energy (kJ)';
export const FAT = 'Fat (g)';
export const SATURATES = 'Of which saturates (g)';
export const CARBS = 'Carbohydrates (g)';
export const SUGARS = 'Of which sugars (g)';
export const FIBRE = 'Fibre (g)';
export const PROTEIN = 'Protein (g)';
export const SALT = 'Salt (g)';

// Price

export const EUR = '€';
export const GBP = '£';
export const FROM = 'From ';

// Section

export const EMPTY_SECTION = `All dishes in this section have been filtered out. Update your
search criteria to view`;
export const REGIONS = {
    England: 'England',
    GB: 'England, Scotland and Wales',
    'Northern Ireland': 'Northern Ireland',
    Scotland: 'Scotland',
    Wales: 'Wales'
};

// Top banner

export const BETA_MENU_TITLE = 'Our menu';
export const BETA_MENU_TEXT =
    'Craving PERi-PERi? You’ve come to the right place!';
export const BETA_MENU_LINK = '';

// VAT notice

export const VAT_NOTICE =
    'Feed your craving for less! We’ve passed on 100% of the VAT saving to you';

// Veggie or Vegan
export const VEGGIE = 'Vegetarian';
export const PLANT_BASED = 'Plant-based';

/* PROGRAMMATIC STRINGS */

//ARIA
export const MENU = 'menu';
export const MENUBAR = 'menubar';
export const MENUITEM = 'menuitem';
export const NAVIGATION = 'navigation';
export const NONE = 'none';
export const SEPARATOR = 'separator';

/* API STRINGS */
export const MAYBE_FROM_KITCHEN_CROSS_CONTAMINATION =
    'MAYBE_FROM_KITCHEN_CROSS_CONTAMINATION';
export const MAYBE_FROM_MANUFACTURING = 'MAYBE_FROM_MANUFACTURING';
export const MAYBE = 'MAYBE';
export const UNKNOWN = 'UNKNOWN';
export const NO = 'NO';
export const COLLECTION = 'COLLECTION';
export const DELIVERY = 'DELIVERY';
export const EAT_IN = 'EAT_IN';
export const AT_TABLE = 'AT_TABLE';
export const YES = 'YES';
